// "El sistema recuerde los teléfonos que escriba el médico y los ofrezca
// como autocompletar" — pedido explícito del usuario 2026-09-02. Alcanza
// con localStorage (conveniencia por navegador/dispositivo, no dato
// clínico que necesite sincronizarse entre sesiones o quedar en el
// expediente) — mismo criterio simple que hceAdminSession.ts.
//
// Clave por `practitionerId` (pedido explícito del usuario, ronda 2): un
// equipo compartido (recepción, consultorio con varios turnos) no debe
// mezclar el teléfono de un practicante con el de otro que usó la misma
// máquina — cada practicante ve solo lo que ÉL escribió, en cualquier
// ficha de paciente que abra.
const PREFIJO_CLAVE = 'logiacare.receta.telefonosPrescriptorRecientes';
const MAX_RECORDADOS = 5;

function claveDe(practitionerId: string): string {
  return `${PREFIJO_CLAVE}:${practitionerId}`;
}

export function telefonosRecientes(practitionerId: string): string[] {
  try {
    const crudo = localStorage.getItem(claveDe(practitionerId));
    if (!crudo) return [];
    const lista = JSON.parse(crudo);
    return Array.isArray(lista) ? lista.filter((t) => typeof t === 'string') : [];
  } catch {
    return [];
  }
}

/** Lo manda al frente de la lista (más reciente primero), sin duplicados, máximo `MAX_RECORDADOS`. */
export function recordarTelefono(practitionerId: string, telefono: string): void {
  const limpio = telefono.trim();
  if (!limpio) return;
  const actuales = telefonosRecientes(practitionerId).filter((t) => t !== limpio);
  const actualizada = [limpio, ...actuales].slice(0, MAX_RECORDADOS);
  try {
    localStorage.setItem(claveDe(practitionerId), JSON.stringify(actualizada));
  } catch {
    // localStorage lleno o bloqueado (modo privado) — es solo una
    // conveniencia de autocompletado, no vale la pena romper el flujo de
    // firma de la receta por esto.
  }
}
